var render = function render(){var _vm=this,_c=_vm._self._c;return _c('center',[_c('div',{attrs:{"classs":"row"}},[_c('h4',{staticStyle:{"color":"#a9a9a9"}},[_vm._v("Loading...")])]),_c('div',{attrs:{"classs":"row"}},[_c('q-circular-progress',{staticClass:"q-ma-md",attrs:{"indeterminate":"","size":"8em","color":"cyan"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }